module.exports = {
  object: {
    label: 'object',
    key: 'object',
  },
  array: {
    label: 'array',
    key: 'array',
  },
  string: {
    label: 'string',
    key: 'string',
  },
  boolean: {
    label: 'boolean',
    key: 'boolean',
  },
  number: {
    label: 'number',
    key: 'number',
  }
};